export default "__VITE_PUBLIC_ASSET__09e69fce__"